import type { Patient } from '../../../types';
import './CompactPatientHeader.scss';

interface PatientIdentityBannerProps {
  patient: Patient;
}

function getInitials(name: string) {
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

export function PatientIdentityBanner({ patient }: PatientIdentityBannerProps) {
  return (
    <div className="patient-id-primary">
      <div className="patient-avatar">{getInitials(patient.name)}</div>
      <span className="patient-name">{patient.name}</span>
      <span className="patient-mrn select-text">{patient.mrn}</span>
      <span className="separator">•</span>
      <span className="patient-dob">
        {patient.dateOfBirth ? `${patient.dateOfBirth} (${patient.age})` : `${patient.age} yrs`}
      </span>
      <span className="separator">•</span>
      <span className="patient-gender">
        {patient.gender === 'M' ? 'M' : patient.gender === 'F' ? 'F' : patient.gender}
      </span>
      {patient.isWatchlisted ? (
        <>
          <span className="separator">•</span>
          <span
            className="inline-flex px-2 py-0.5 text-xs font-semibold rounded-full whitespace-nowrap"
            style={{ backgroundColor: '#FEF3C7', color: '#92400E', border: '1px solid #FDE68A' }}
          >
            Watchlisted
          </span>
        </>
      ) : null}
    </div>
  );
}
